export const BarCodeCardReversePosition = [
    {
        id: 1,
        name: "Right Bottom"
    },
    {
        id: 2,
        name: "Left Bottom"
    },
    {
        id: 3,
        name: "Other (Right Middle)"
    },    
]